import * as Sentry from '@sentry/react';
import {useEffect} from 'react';
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

const initSentry = () => {
  // VITE_SENTRY_DSN is required to send events
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: import.meta.env.VITE_SENTRY_RELEASE ?? '',
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',
    ignoreErrors: ['Failed to fetch dynamically imported module'],
    denyUrls: ['https://fast.chameleon.io'],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,

    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        createRoutesFromChildren,
        matchRoutes,
        useEffect,
        useLocation,
        useNavigationType,
      }),
    ],
  });

  return {
    createBrowserRouter: Sentry.wrapCreateBrowserRouterV7(createBrowserRouter),
  };
};

export default initSentry;
